import React from 'react'

const SectionHeaderBar = ({ heading, subHeading, selectedCount }) => {
    return (
        <div className='bg-sectionheaderbg border border-bordercolor rounded-xl px-2 py-3'>
            <h1 className="text-lg font-bold text-textprimary">
                {heading}
            </h1>

            <p className="text-xs text-textsecondary mt-1 flex items-center gap-2">
                {subHeading}
                {selectedCount && <span className="text-[10px] font-bold px-2 py-1 rounded-lg bg-secondaryaccent text-primaryaccent border border-accentborder">
                    {selectedCount.length} Selected
                </span>}
            </p>
        </div>
    )
}

export default SectionHeaderBar